import React from "react";
import borderRightImg from "../../assets/images/webp/other/border-right.webp";
import { BUSINESS_LIST } from "../../utils/other-component";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Paragraph from "../common/ui/Paragraph";

const MoreBussiness = () => {
  return (
    <>
      <div className="bg-cover px-4 bg-center bg-no-repeat bg-more-bussiness-bg">
        <div className="py-[182px] max-xl:py-36 max-lg:py-24 max-md:py-16 max-sm:py-10">
          <div className="flex items-center justify-center flex-col">
            <BlueTag variant="white" center>
              Philosophy & Vision
            </BlueTag>
            <h2 className="text-6xl max-xl:text-[50px] max-lg:text-5xl max-md:text-4xl max-sm:text-3xl font-bold leading-[120%] text-white max-w-[598px] mx-auto text-center pt-2">
              More Than Business – A Way of Life
            </h2>
            <Paragraph className="pt-4" variant="white">
              Every vision starts with belief. Success is simply belief put into
              consistent action.
            </Paragraph>
            <div className="flex items-center gap-[22px] flex-wrap max-lg:gap-4 pt-10">
              {BUSINESS_LIST.map((obj, i) => (
                <div key={i} className="flex items-center gap-4">
                  <div className="flex items-center gap-2">
                    <Icons icon={obj.icon} />
                    <h4 className="text-[#FAFAFA] font-medium text-2xl leading-[145%] ff-helvetica">
                      {obj.name}
                    </h4>
                  </div>
                  {i !== BUSINESS_LIST.length - 1 && (
                    <img
                      src={borderRightImg}
                      width={4}
                      height={27}
                      alt="line"
                      className="h-[27px]"
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MoreBussiness;
